import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import GoBeyondIcon from 'assets/icons/footer/footer_gobeyond_icon_funding.png';
import UpArrowIcon from 'assets/icons/footer/up_arrow_icon.png';
import { ReactComponent as Reject } from 'assets/icons/Reject.svg';
import { ReactComponent as Approve } from 'assets/icons/Approve.svg';
import { isCoe } from '../../utils/index';
import { useInvestorApplicationValidation } from '../../hooks/useInvestorApplicationValidation';
import styles from './FormsFooter.module.css';

const Footer = () => {
  const location = useLocation();
  const user = useSelector(state => state.user.groups);
  const isMainForms = location.pathname.includes('main-forms');
  const isViewForm = location.pathname.includes('viewForm');
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // === Special Footer for main-forms / appTrack pages ===
  if (isMainForms) {
    return null;
  }

  if (isViewForm && isCoe(user.groups)) {
    return (
      <div className={styles.formsFooterContainer}>
        <div className={styles.formsFooter}>
          {/* Left Section */}
          <div className={styles.formsFooterLeft}>
            <button className={`${styles.btn} ${styles.purpleBtn}`}>
              ← Πίσω στην My Funding
            </button>
            <button className={`${styles.btn} ${styles.purpleBtn}`}>
              Επόμενο →
            </button>
          </div>

          {/* Right Section */}
          <div className={styles.formsFooterRight}>
            <button className={`${styles.Reject} ${styles.outlinedBtn}`}>
              <Reject style={{ marginRight: 6 }} />
              Απόρριψη
            </button>
            <button className={`${styles.Approve} ${styles.grayBtn}`}>
              <Approve style={{ marginRight: 6 }} />
              Approve
            </button>
          </div>
        </div>
      </div>
    );
  } else if (isViewForm) {
    return <div></div>;
  }

  return (
    <div id="footer-container">
      <div id="footer-content" className="main-container">
        {/* Logo and text */}
        <div id="footer-logo-part">
          <img src={GoBeyondIcon} alt="GoBeyond Icon" />
          <p>© 2024 Grant Thornton media. All rights reserved.</p>
        </div>

        {/* Left links */}
        <div id="footer-links-left">
          <ul>
            <li>About</li>
            <li>Give & Receive</li>
            <li>Cookie Policy</li>
            <li>Όροι και Προϋποθέσεις</li>
          </ul>
        </div>

        {/* Right links */}
        <div id="footer-links-right">
          <ul>
            <li>Facebook</li>
            <li>Twitter</li>
            <li>LinkedIn</li>
            <li>Instagram</li>
          </ul>
        </div>

        {/* Scroll to top */}
        <div id="footer-scroll-top" onClick={scrollToTop}>
          <img src={UpArrowIcon} alt="Scroll to top" />
        </div>
      </div>
    </div>
  );
};

export default Footer;
